import { BooleanInput, TextInput } from "@/components/admin";
import { useWatch } from "react-hook-form";

// Independent Bill To / Ship To toggles; each shows its own auto-filled address.
export const DCAddressFields = () => {
  const showBill = useWatch({ name: "show_bill_to" });
  const showShip = useWatch({ name: "show_ship_to" });
  return (
    <div className="w-full space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full [&>*]:min-w-0">
        <BooleanInput source="show_bill_to" label="Bill To" defaultValue={true} helperText={false} />
        <BooleanInput source="show_ship_to" label="Ship To" defaultValue={false} helperText={false} />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full [&>*]:min-w-0">
        {showBill !== false && (
          <TextInput
            source="bill_to_address"
            label="Bill To Address (auto-filled from company)"
            multiline
            rows={4}
            className="w-full"
            helperText={false}
          />
        )}
        {!!showShip && (
          <TextInput
            source="ship_to_address"
            label="Ship To Address (auto-filled from company)"
            multiline
            rows={4}
            className="w-full"
            helperText={false}
          />
        )}
      </div>
    </div>
  );
};
